import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import { Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import * as data from '../../../../assets/data/data.json';
import { Papa } from 'ngx-papaparse';
import { ValidateCsvService } from '../../../services/validateCsv.service';
import { Md5 } from 'ts-md5/dist/md5';
import { Router } from '@angular/router';

@Component({
  selector: 'app-salary-upload',
  templateUrl: './salary-upload.component.html'
})
export class SalaryUploadComponent implements OnInit {
  months = this.constantService.MONTHS;
  filterParams = {
    month: moment().subtract(1, "month").format("MM"),
    year: moment().format("YYYY"),
    org_id: ''
  };
  years = [
    moment().format("YYYY"),
    moment().subtract(1, "years").format("YYYY"),
    moment().subtract(2, "years").format("YYYY"),
    moment().subtract(3, "years").format("YYYY"),
    moment().subtract(4, "years").format("YYYY")
  ];
  constructor(private profileService: ProfileService,
    private constantService: ConstantService,
    private apiService: ApiService,
    private papa: Papa,
    private validateCsvService: ValidateCsvService,
    private router: Router) {

  }

  ngOnInit(): void {
    this.fetchOrg();
  }


  organizationList: any = [];
  fetchOrg() {
    this.apiService.getData('organization').then((resp) => {
      this.organizationList = resp;
    })
  }



  @ViewChild('fileImportInput') fileImportInput: ElementRef;
  private entry_operator_id = "";


  csvHeaderFields = ['employee_id', 'employee_name', 'phone_number', 'employee_location', 'designation', 'gender', 'date_of_joining', 'date_of_birth', 'esic_account_no', 'sa_policy_no', 'uan', 'pan', 'bank_account_no', 'ifsc_code', 'bank_name', 'status', 'calender_days', 'paid_days', 'lop_days', 'base_salary', 'hra', 'transport_allowance', 'communication_allowance', 'mobile_allowance', 'special_allowance', 'pf_employer', 'performance_incentive', 'education_allowance', 'total_earning', 'pf_deduction', 'pf_employer_deduction', 'employee_state_insurance', 'group_insurance_deduction', 'tds_deduction', 'prof_tax_deduction', 'gst_deduction', 'service_charge_deuction', 'excess_pay_adjustment', 'deduction_against_dept_ord', 'generic_advance', 'tds_due_adjustment', 'total_deduction', 'net_salary', 'total_ctc_without_tax', 'total_ctc_with_tax'];
  // csvHeaderFields = ["userType","username","password","fullName","contactNo","permission"];
  isHeader: any = false;
  csvErrorMsg: any = null;
  isCsvBlank: any = false;
  records = {
    recordsUploaded: 0,
    totalRecords: 0,
    progress: 0
  };
  patientDetailClone: any = {};
  flag = {
    enableSave: false
  }


  csvRecords: any[] = [];
  rawCsv = null;
  header = true;
  csvContent: string;
  formattedData = [];
  loadCsvFile($event: any) {
    // Select the files from the event
    const files = $event.srcElement.files;
    let that = this;
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        that.rawCsv = reader.result as string;
        //  console.log(that.rawCsv);
        that.parseCSV();
      }
    }

  }

  parseCSV() {
    let that = this;
    let options = {
      header: true,
      complete: (results, file) => {
        console.log('Parsed: ', results);
        that.csvRecords = results.data;
        that.validateCSV(that.csvRecords, results.meta.fields);
      }
    }
    this.papa.parse(this.rawCsv, options);
  }




  table_header = "(`org_id`, `employee_id`,  `employee_name`, `phone_number`, `employee_location`, `designation`, `gender`,`date_of_joining`, `date_of_birth`, `esic_account_no`, `sa_policy_no`, `uan`, `pan`, `bank_account_no`, `ifsc_code`, `bank_name`, `status`, `calender_days`, `paid_days`, `lop_days`, `month`, `year`, `base_salary`, `hra`, `transport_allowance`, `communication_allowance`,`medical_allowance`, `mobile_allowance`, `special_allowance`, `pf_employer`,`performance_incentive`, `education_allowance`, `total_earning`, `pf_deduction`, `pf_employer_deduction`,`employee_state_insurance`, `group_insurance_deduction`, `tds_deduction`, `prof_tax_deduction`, `gst_deduction`,	`service_charge_deuction`, `excess_pay_adjustment`, `generic_advance`, `tds_due_adjustment`, `total_deduction`, `net_salary`, `total_ctc_without_tax`,	`total_ctc_with_tax`,`secret_key`)";

  secretKey() {
    let sec_key = this.makeid(5);
    return Md5.hashStr(sec_key);
  }

  convertBigInt(number) {
    console.log(number, +number);
    return +number;
  }

  validateCSV(csv, csvFields) {
    // console.log(csv)
    if (csv.length === 0) {
      this.isHeader = false;
      this.isCsvBlank = true;
      this.csvErrorMsg = {
        blank_error: 'CSV file must contain atleast 1 record'
      }
    } else {
      console.log(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields))
      if (!_.isEqual(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields))) {
        this.isHeader = false;
        this.isCsvBlank = false;
        let diff: string[] = _.difference(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields));
        console.log(diff)
        this.csvErrorMsg = {
          header_required: 'CSV file must contain these header ' + diff.join(", ") + " or check spellings",
          // header_available: 'Existing CSV file contains header in format [' + csv[0] + ' ] ',
        };
      } else {
        this.isHeader = true;
        this.isCsvBlank = false;
        this.csvErrorMsg = {};
        _.each(this.csvRecords, (record) => {
          console.log(record);
          if (record['employee_id'] !== undefined && record['employee_id'] !== '') {
            this.formattedData.push("( '" + this.clean(this.filterParams.org_id) + "', '" + this.clean(record['employee_id']) + "', '" + this.clean(record['employee_name']) + "', '" + this.clean(record['phone_number']) + "', '" + this.clean(record['employee_location']) + "', '" + this.clean(record['designation']) + "', '" + this.clean(record['gender']) + "', '" +
              this.clean(record['date_of_joining']) + "', '" + this.clean(record['date_of_birth']) + "', '" + record['esic_account_no'] + "', '" + record['sa_policy_no'] + "', '" + record['uan'] + "', '" + record['pan'] + "', '" + this.clean(record['bank_account_no']) + "', '" + this.clean(record['ifsc_code']) + "', '" +
              this.clean(record['bank_name']) + "', '" + this.clean(record['status']) + "', '" + + this.clean(record['calender_days']) + "', '" + + this.clean(record['paid_days']) + "', '" + + this.clean(record['lop_days']) + "', '" + this.clean(this.filterParams.month) + "', '" + this.filterParams.year + "', '" + record['base_salary'] + "', '" + record['hra'] + "', '" + record['transport_allowance'] + "', '" + record['communication_allowance'] + "', '" +
              record['medical_allowance'] + "', '" + record['mobile_allowance'] + "', '" + record['special_allowance'] + "', '" + record['pf_employer'] + "', '" + record['performance_incentive'] + "', '" +
              record['education_allowance'] + "', '" + record['total_earning'] + "', '" + record['pf_deduction'] + "', '" + record['pf_employer_deduction'] + "', '" + record['employee_state_insurance'] + "', '" + record['group_insurance_deduction'] + "', '" + record['tds_deduction'] + "', '" + record['prof_tax_deduction'] + "', '" + record['gst_deduction'] + "', '" + record['service_charge_deuction'] + "', '" +
              record['excess_pay_adjustment'] + "', '" + record['generic_advance'] + "', '" + record['tds_due_adjustment'] + "', '" + record['total_deduction'] + "', '" + record['net_salary'] + "', '" + record['total_ctc_without_tax'] + "', '" + record['total_ctc_with_tax'] + "', '" + this.secretKey() + "')");
          }
        })
        console.log(this.formattedData);
        this.flag.enableSave = true;
      }
    }
  };

  clean(str) {
    // if (str) {
    //   return (_.trim(str.replace(/[^\w\s]/g, '')));
    // } else {
    //   return str;
    // }
    return str;
  }

  parseNumer(i) {
    if (i) {
      return (parseInt(i)).toFixed();
    } else {
      return '';
    }
  }

  successMsg: string = "";
  csvUpload() {
    let that = this;
    this.records.totalRecords = this.formattedData.length;
    let chunkSize = 200;
    let chunkData = _.chunk(_.slice(this.formattedData, 0), chunkSize);
    this.records.recordsUploaded = 0;
    let i = 0;
    _.each(chunkData, (data) => {
      setTimeout((val) => {
        let payload = {
          header: btoa(unescape(encodeURIComponent(this.table_header))),
          data: btoa(unescape(encodeURIComponent(data)))
        }
        console.log(this.table_header, data);
        this.apiService.addBulkData('salary_structure', payload).subscribe((response) => {
          that.records.recordsUploaded = that.records.recordsUploaded + data.length;
          console.log(that.records.recordsUploaded + " - " + that.records.totalRecords);
          console.log((that.records.recordsUploaded * 100) / that.records.totalRecords);
          that.records.progress = (that.records.recordsUploaded * 100) / that.records.totalRecords;

          if (that.records.progress === 100) {
            this.successMsg = "Records successfully uploaded.";
            setTimeout(() => {
              that.records.recordsUploaded = 0;
              this.router.navigate(['/salary'])
            }, 2000)
          }
        })
      }, i * 3000);
      i++;

    })
  }

  resetUpload() {
    this.fileImportInput.nativeElement.value = '';
    this.records = {
      recordsUploaded: 0,
      totalRecords: 0,
      progress: 0
    };
    this.csvRecords = [];
    this.csvContent = '';
    this.formattedData = [];
    this.csvErrorMsg = {};
    // this.selectedVehicleId = '';
    // this.selectList.nativeElement.value = 'Select Vehicle';
  }


  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

}
